import { component, prop, getter } from '../../../decorators';

import RavnurPlayer from 'player';

import extend from 'lodash/extend';

/* eslint camelcase: 0 */

const HOUR = 3600; // sec

const OPTIONS = {
   flashPath: '/static/',
   hlsjsURL: '/static/hls.min.js',

   showTitle: false,
   showHelp: false,
   showFullScreen: true,
   showVolume: true,
   showBackward: true,
   showForward: true,
   showSettings: true,
   showCCLayout: false,

   hls: {
      maxFragLookUpTolerance: 0.001,
      maxMaxBufferLength: 20
   }
};

const MS_IN_SEC = 1000;

@component
export default class ClipPlayer {
   @prop({ type: Number, default: 0 }) startTime
   @prop({ type: Number, default: Number.MAX_VALUE }) endTime
   @prop({ required: true }) sources
   @prop({ type: Boolean, default: false }) lazy

   loaded = false

   player = null

   @getter() getCurrentUser
   @getter() getMuxApiKey

   get mux() {
      return {
         property_key: this.getMuxApiKey,
         viewer_user_id: this.getCurrentUser.id,
         video_id: this.sources.id,
         video_title: this.sources.title,
         video_content_type: 'clip',
         video_duration: this.sources.duration
      };
   }

   show() {
      this.loaded = true;

      const startTime = this.startTime / MS_IN_SEC;
      const endTime = this.endTime / MS_IN_SEC;
      this.player = new RavnurPlayer(this.$refs.player);
      const source = extend({ }, this.sources);
      source.timecode = source.timecode / MS_IN_SEC;
      const start = +(startTime.toFixed(2) - source.timecode).toFixed(2);
      const end = +(endTime.toFixed(2) - source.timecode).toFixed(2);
      source.clip = [ start, end ];

      source.timecode = +(HOUR - start).toFixed(2);

      this.player.setup(source, { ...OPTIONS, mux: this.mux });
   }

   playClip() {
      this.show();
      this.player.controller.play();
   }

   mounted() {
      if ( !this.lazy ) {
         this.show();
      }
   }

   beforeDestroy() {
      if (this.player) {
         this.player.destroy();
      }
   }
}
